<div class="is-hidden-print bg-body-tertiary p-5">
    <div class="container">
        <div class="row">
            <div class="col-lg">
                <p class="lead" i18n>Data Donation</p>
                <p>
                    <a [href]="environment.sourceUrl" target="_blank" i18n>Source code</a>&nbsp;<ng-container i18n>(BSD 3-Clause License)</ng-container>
                </p>
                <p>
                    <em><ng-container i18n>Version: </ng-container><span>{{environment.version}}</span>&nbsp;(<span [title]="environment.buildTime">{{buildTime}})</span></em>
                </p>
            </div>
            <div class="col-lg-auto">
                <a class="centre-logo"
                    href="https://cdh.uu.nl/about/research-software-lab/" target="_blank">
                    <img [src]="environment.assets + (dark ? '/uu-cdh-dark.svg' :'/uu-cdh.svg')"
                        alt="Centre for Digital Humanities, Utrecht University" i18n-alt width="450" height="105" />
                </a>
            </div>
        </div>
    </div>
</div>
